import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation, withRouter } from 'react-router';
import Header from '../components/Header';
import NotFound from '../components/NotFound';
import Admin from '../components/admin/index';
import AppChoicesProvider from '../components/app-choices/AppChoicesProvider';
import { MunicipalityCountyProvider } from '../hooks/useMunicipalityCounty';
import Dashboard from '../components/dashboard/Dashboard';
import Hoa from '../components/hoas/Hoa';
import Profile from '../components/profile';
import Services from '../components/services/Services';
import Tasks from '../components/tasks/Tasks';
import { makeRESTApiRequest } from '../helpers/api';
import { ENDPOINTS, ROLES_TO_WHICH_ADMIN_SECTION_IS_NOT_VISIBLE } from '../helpers/constants';
import { getUserFromLocalstrorage, isClient, isSalesPerson, isStaff } from '../helpers/global';
import { saveUserToLocal } from '../helpers/session';
import OrgDashboard from '../components/common/OrgDashboard/OrgDashboard';
import TurnaroundTimes from '../components/Turnaround/TurnaroundTimes';
import StatementPage from '../components/statement/StatementPage';

const AuthenticatedApp = () => {
  const loggedInToken = localStorage.getItem('user-token');
  const [currentUserInfo, setCurrentUserInfo] = useState(getUserFromLocalstrorage()); // State For Real Time User Name Update In Header Section
  const [dataCommunicateMeta, setDataCommunicateMeta] = useState({});
  const location = useLocation();

  const onCurrentUserInfoChange = userInfo => setCurrentUserInfo(userInfo);

  const handleDataCommunicateMeta = (key, value) => {
    setDataCommunicateMeta({ ...dataCommunicateMeta, [key]: value });
  };

  useEffect(() => {
    const getAuth = async () => {
      const { response: authResult, error } = await makeRESTApiRequest({
        endpoint: ENDPOINTS.USERS_ME,
        method: 'GET'
      });

      if (authResult) {
        saveUserToLocal(authResult, false);
        setCurrentUserInfo(authResult);
      }
    };

    if (loggedInToken) {
      getAuth();
    }
  }, [loggedInToken]);

  if (loggedInToken && location.pathname === '/') {
    return (
      <Redirect
        from="/"
        to={`${
          isClient(currentUserInfo?.role)
            ? '/org-dashboard'
            : isStaff(currentUserInfo?.role)
            ? '/dashboard'
            : '/services/pipeline'
        }`}
      />
    );
  }

  if (!loggedInToken) {
    return <Redirect from="/" to="/login" />;
  }

  return (
    <AppChoicesProvider>
      <MunicipalityCountyProvider>
        <Header currentUserInfo={currentUserInfo} onServiceCreated={handleDataCommunicateMeta} />
        <div style={{ paddingTop: '64px', height: '100%' }}>
          <Switch>
            <Route path="/profile" exact>
              <Profile onCurrentUserInfoChange={onCurrentUserInfoChange} />
            </Route>
            {isStaff(currentUserInfo?.role) && (
              <Route path="/dashboard" exact>
                <Dashboard currentUserInfo={currentUserInfo} />
              </Route>
            )}
            <Route path="/org-dashboard" exact>
              <OrgDashboard />
            </Route>
            {!ROLES_TO_WHICH_ADMIN_SECTION_IS_NOT_VISIBLE.includes(currentUserInfo?.role) && (
              <Route path="/admin">
                <Admin currentUserInfo={currentUserInfo} />
              </Route>
            )}

            {!isSalesPerson(currentUserInfo?.role) && (
              <Route path="/services">
                <Services
                  createdService={dataCommunicateMeta['newOrder'] || null}
                  onServiceHandled={() => handleDataCommunicateMeta('newOrder', null)}
                />
              </Route>
            )}

            {!isSalesPerson(currentUserInfo?.role) && (
              <Route path="/tasks">
                <Tasks />
              </Route>
            )}
            {!isSalesPerson(currentUserInfo?.role) && (
              <Route path="/hoa">
                <Hoa />
              </Route>
            )}
            {!isSalesPerson(currentUserInfo?.role) && (
              <Route path="/turnaround-times">
                <TurnaroundTimes />
              </Route>
            )}
            {isClient(currentUserInfo?.role) && (
              <Route path="/statement">
                <StatementPage />
              </Route>
            )}
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </MunicipalityCountyProvider>
    </AppChoicesProvider>
  );
};

export default withRouter(AuthenticatedApp);
